/* ZHIVA — global.js : light progressive enhancement, no dependencies */
(function () {
  'use strict';

  // Mobile nav toggle
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-mobile-nav]');
      if (nav) nav.hidden = !nav.hidden;
    }
  });

  // Product gallery: swap main image from thumbnails
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (main && full) main.src = full;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  });

  // Variant selector -> update hidden id + price
  document.querySelectorAll('[data-variant-form]').forEach(function (form) {
    var data = form.querySelector('[data-variant-json]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = form.querySelector('[data-variant-price]');
    var btn = form.querySelector('[data-add-btn]');
    var select = form.querySelector('[data-variant-select]');
    if (!select) return;

    function money(cents) {
      return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2 });
    }
    select.addEventListener('change', function () {
      var v = variants.find(function (x) { return String(x.id) === select.value; });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.getAttribute('data-label') : 'Sold';
      }
    });
  });
})();
